import { useRef } from "react";
import { useSnapshot } from "valtio";
import klimaTimebarState from "./states/klimaTimebarState";
import { stateNavigation, stateDevice } from "../../store";

const MIN_YEAR = 1856;
const MAX_YEAR = 2100;
const PAD = 40;

// CSS approximation of the 3D farbbalken color gradient
const FARBBALKEN = "linear-gradient(to right, #1a4fa0, #3a89c9, #88c4de, #c4e5e0, #f5e87a, #f09428, #c82010, #7a0000)";

export default function KlimaTimebar2D() {
  const snap = useSnapshot(klimaTimebarState);
  const snapNav = useSnapshot(stateNavigation);
  const snapDevice = useSnapshot(stateDevice);
  const trackRef = useRef(null);
  const dragging = useRef(false);

  const isPortrait = snapDevice.isPortrait;
  const containerWidth = isPortrait
    ? "100%"
    : `calc(100% - ${snapNav.sidebarWidth}px)`;

  const pos = Math.max(0, Math.min(1, snap.position));
  const year = Math.round(MIN_YEAR + (MAX_YEAR - MIN_YEAR) * pos);

  const clamp01 = (v) => Math.max(0, Math.min(1, v));

  const applyFromClientX = (clientX) => {
    const rect = trackRef.current.getBoundingClientRect();
    const usable = rect.width - PAD * 2;
    const p = clamp01(usable > 0 ? (clientX - rect.left - PAD) / usable : 0);
    klimaTimebarState.position = p;
  };

  const onPointerDown = (e) => {
    dragging.current = true;
    trackRef.current?.setPointerCapture(e.pointerId);
    applyFromClientX(e.clientX);
  };
  const onPointerMove = (e) => { if (dragging.current) applyFromClientX(e.clientX); };
  const onPointerUp = () => { dragging.current = false; };

  const handleLeftPct = `calc(${PAD}px + ${pos.toFixed(4)} * (100% - ${PAD * 2}px))`;

  return (
    <div style={{
      position: "fixed", left: 0, width: containerWidth,
      bottom: isPortrait ? "calc(31vh + 85px)" : "150px",
      display: "flex", justifyContent: "center",
      zIndex: 5, pointerEvents: "none",
    }}>
      <div style={{
        width: isPortrait ? "min(94vw, 480px)" : "min(60vw, 580px)",
        background: "rgba(0,0,0,0.52)", borderRadius: 10,
        padding: isPortrait ? "10px 8px 4px" : "10px 20px 14px",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        userSelect: "none", WebkitUserSelect: "none", pointerEvents: "auto",
      }}>
        {/* Track */}
        <div ref={trackRef} style={{
          position: "relative", height: isPortrait ? 28 : 46,
          touchAction: "none", cursor: "ew-resize",
        }}
          onPointerDown={onPointerDown} onPointerMove={onPointerMove}
          onPointerUp={onPointerUp} onPointerCancel={onPointerUp}>

          {/* Farbbalken gradient track */}
          <div style={{
            position: "absolute", top: "50%",
            left: PAD, right: PAD,
            transform: "translateY(-50%)",
            height: 8, borderRadius: 4,
            background: FARBBALKEN,
            pointerEvents: "none",
          }} />

          {/* Left cap circle */}
          <div style={{
            position: "absolute", left: PAD, top: "50%",
            transform: "translate(-50%, -50%)",
            width: 28, height: 28, borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.5)",
            background: "rgba(0,0,0,0.4)",
            pointerEvents: "none",
          }} />

          {/* Right cap circle */}
          <div style={{
            position: "absolute", left: `calc(100% - ${PAD}px)`, top: "50%",
            transform: "translate(-50%, -50%)",
            width: 28, height: 28, borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.5)",
            background: "rgba(0,0,0,0.4)",
            pointerEvents: "none",
          }} />

          {/* Handle */}
          <div style={{
            position: "absolute", left: handleLeftPct, top: "50%",
            transform: "translate(-50%, -50%)",
            width: 28, height: 28, borderRadius: "50%",
            background: "#262626", border: "1.5px solid #fc8207",
            boxShadow: "0 0 10px rgba(252,130,7,0.4), 0 2px 6px rgba(0,0,0,0.5)",
            zIndex: 3, pointerEvents: "none",
          }} />
        </div>

        {/* Current year label */}
        <div style={{
          textAlign: "center", color: "#dddddd", fontSize: isPortrait ? 11 : 13,
          letterSpacing: "0.4px", marginTop: isPortrait ? 0 : 8,
          lineHeight: isPortrait ? "11px" : "normal", minHeight: isPortrait ? 11 : 18,
        }}>
          {year}
        </div>

        {/* Year range end labels */}
        <div style={{
          display: "flex", justifyContent: "space-between",
          paddingLeft: PAD - 14, paddingRight: PAD - 14,
          color: "rgba(255,255,255,0.45)", fontSize: 11, marginTop: isPortrait ? 1 : 3,
        }}>
          <span>{MIN_YEAR}</span>
          <span>{MAX_YEAR}</span>
        </div>
      </div>
    </div>
  );
}
